import { Box, Grid, TextField, Typography, InputAdornment } from "@mui/material"
import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import AppContext from "../../../../AppContext"
import { ListItemInterface } from "../../../../useApp"
import { EngraisInterface, Engrais$ } from "../../../../_api/_engrais"
import ImageUploader from "../../../ImageUploader"
import Page from "../../../Page/Page"
import { SelectCustomEnum, SelectCustomMultiple } from "../../../SelectCustom"


const EditEngrais = () => {
    const navigate = useNavigate()
    const params = useParams()
    const { api } = React.useContext(AppContext)
    const [data, setData] = React.useState<EngraisInterface>()

    const handleChangeName = (event: any) => setData({ ...(data as EngraisInterface), name: event.target.value })
    const handleChangeType = (event: string) => setData({ ...(data as EngraisInterface), type: event })
    const handleChangeK = (event: any) => setData({ ...(data as EngraisInterface), composition: { ...(data as EngraisInterface).composition, K: +event.target.value } })
    const handleChangeN = (event: any) => setData({ ...(data as EngraisInterface), composition: { ...(data as EngraisInterface).composition, N: +event.target.value } })
    const handleChangeP = (event: any) => setData({ ...(data as EngraisInterface), composition: { ...(data as EngraisInterface).composition, P: +event.target.value } })
    const handleChangeModeUsage = (options: ListItemInterface[]) => setData({ ...(data as EngraisInterface), modesUsage: options })
    const handleChangeMomentUsage = (options: ListItemInterface[]) => setData({ ...(data as EngraisInterface), momentsUsage: options })
    const handleChangeSol = (event: string) => setData({ ...(data as EngraisInterface), ensoleil: event })


    const hasChange = () => {
        if (!data) return false
        let oldEngrais = Engrais$.getValue() as EngraisInterface;
        if (oldEngrais.name !== data.name) return true
        if (oldEngrais.type !== data.type) return true
        if (JSON.stringify(oldEngrais.composition) !== JSON.stringify(data.composition)) return true
        if (JSON.stringify(oldEngrais.modesUsage) !== JSON.stringify(data.modesUsage)) return true
        if (JSON.stringify(oldEngrais.momentsUsage) !== JSON.stringify(data.momentsUsage)) return true
        if (oldEngrais.ensoleil !== data.ensoleil) return true

        return false;
    }

    const handleSave = () => {
        if (!data) return false
        let newEngrais: Partial<EngraisInterface> = {}
        let oldEngrais = Engrais$.getValue() as EngraisInterface;
        if (oldEngrais.name !== data.name) newEngrais.name = data.name
        if (oldEngrais.type !== data.type) newEngrais.type = data.type
        if (JSON.stringify(oldEngrais.composition) !== JSON.stringify(data.composition)) newEngrais.composition = data.composition
        if (JSON.stringify(oldEngrais.modesUsage) !== JSON.stringify(data.modesUsage)) newEngrais.modesUsage = data.modesUsage
        if (JSON.stringify(oldEngrais.momentsUsage) !== JSON.stringify(data.momentsUsage)) newEngrais.momentsUsage = data.momentsUsage
        if (oldEngrais.ensoleil !== data.ensoleil) newEngrais.ensoleil = data.ensoleil

        api.jardin.engrais.put(data.id, newEngrais)
    }

    const handleDelete = () => api.jardin.engrais.delete(params.id as EngraisInterface['id']).then(success => success && navigate(`/jardin/engrais`))

    React.useEffect(() => {
        Engrais$.subscribe(l => {
            if (l) {
                setData(l)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (!data || data.id !== params.id) {
            api.jardin.engrais.get(params.id as string)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id])
    return (
        <Page
            title={{
                title: data ? data.name : "Engrais",
                imageUrl: data && data.imageId ? `/download/${data.imageId}` : undefined,
            }}
            footer={{
                handleSave: handleSave,
                disabledSave: hasChange(),
                handleDelete: handleDelete,
                handleCancel: () => hasChange() ? setData(Engrais$.getValue() as EngraisInterface) : navigate(`/jardin/engrais/${params.id}`),
                cancelPlaceholder: hasChange() ? 'Annuler' : 'Retour'
            }}
            loading={!data}
        >
            {data &&
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                label="Nom du l'engrais"
                                fullWidth
                                value={data.name}
                                onChange={handleChangeName}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectCustomEnum label="Type d'engrais" value={data.type} options={['Minéral', 'Organique', 'Organo-minéral', 'Vert']} onChange={handleChangeType} />
                        </Grid>
                        <Grid item xs={6}>
                            <ImageUploader data={data} callApi={api.jardin.engrais} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="caption" color="text.secondary">Composition</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        label="Potasse"
                                        fullWidth
                                        value={data.composition.K || ''}
                                        onChange={handleChangeK}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        label="Nitrate"
                                        fullWidth
                                        value={data.composition.N || ''}
                                        onChange={handleChangeN}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        label="Phosphate"
                                        fullWidth
                                        value={data.composition.P || ''}
                                        onChange={handleChangeP}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <SelectCustomMultiple label="Mode d'utilisation" value={data.modesUsage?.map(d => d.id) || []} type="jarEngUsage" onChange={handleChangeModeUsage} />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectCustomMultiple label="Moment d'utilisation" value={data.momentsUsage?.map(d => d.id) || []} type="jarEngMoment" onChange={handleChangeMomentUsage} />
                        </Grid>
                        <Grid item xs={6}>
                            <SelectCustomEnum label="Ensoleillement" value={data.ensoleil} options={['Ensoleillé', 'Non ensoleillé', 'Tous temps']} onChange={handleChangeSol} />
                        </Grid>
                    </Grid>
                </Box>
            }

        </Page >
    )
}

export default EditEngrais